import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Stack } from "@fluentui/react/lib/Stack";

import { get, STORAGE_KEYS, save } from "API/LocalStorage";
import { uiSetToolbarIconsOnly } from "Store/Actions";
import { selectIsToolbarIconsOnly } from "Store/Selectors/UI";
import { Checkbox } from "@fluentui/react/lib/Checkbox";
import { IWithTranslatorProps, WithTranslator } from "Components/Generic/Translator";

export const ToolbarIconsOnly = WithTranslator((props: IWithTranslatorProps): JSX.Element => {
  const { translator } = props;

  const dispatch = useDispatch();

  const setToolbarToIconsOnly = useCallback(() => {
    const isShowingIconsOnly = get<boolean>(STORAGE_KEYS.TOOLBAR_ONLY_ICONS);
    save(STORAGE_KEYS.TOOLBAR_ONLY_ICONS, !isShowingIconsOnly);
    dispatch(uiSetToolbarIconsOnly(!isShowingIconsOnly));
  }, [dispatch]);

  return (
    <Stack horizontal>
      <Checkbox
        label={translator.get(`settings.toolbar.iconsonly.label`, `Toolbar: show icons only`)}
        checked={useSelector(selectIsToolbarIconsOnly)}
        onChange={() => setToolbarToIconsOnly()}
      />
    </Stack>
  );
});
